import React from 'react';
import { Line } from 'rc-progress';
import './Loader.css';

type Props = {
  message: string;
  percent: number;
};

const Loader = ({ message, percent }: Props) => (
  <div className="loader">
    <span className="loader__title">{message}</span>
    <Line
      className="loader__line"
      percent={percent}
      strokeWidth={1}
      strokeColor="#03A9F4"
      trailColor="#aaa"
    />
  </div>
);

export default Loader;
